/*
実プロダクト開発演習。本番のゆめさくを受講生と一緒に開発する演習で、スキルマップでは
道の終点の先にある「本番の開発」として置く。

受講生なら学習の途中でも参加できるので、要るスキルの線と鍵は付けない。値段は出さない。
申し込み済み・参加中の印はデータがまだ無いので出さない
*/
export const PROD_DEV_EXERCISE = {
  id: "prod-dev",
  title: "実プロダクト開発演習",
  place: "本番の開発",
  lines: [
    "本番のサービスに機能を足し、現役エンジニアのレビューを受けて出す",
    "受講生なら学習の途中でも参加できる",
  ],
  start: "第 1 期は 2026 年 12 月から",
  /** いま募集している期。ダッシュボードの入口の題に添える */
  term: "第 1 期",
  /** LP の募集の締め切り (日本の日付、この日の終わりまで)。過ぎたらダッシュボードの入口から締め切りの行を消す */
  recruit: { label: "第 1 次募集", deadline: "2026-10-17" },
  /** 演習の LP。買っていない人の「申し込む」もここへ送る (値段と割引の字は LP と支払いの頁が持つ。ここには写さない) */
  lpUrl: "https://yumesaku.tech/women/lp/prod-dev",
  /** 生涯サポートプランへのアップグレードと一緒に申し込む支払いの頁 */
  payWithUpgradeUrl: "https://yumesaku.tech/women/lp/pay/upgrade?prodDev=1",
  /** 実プロダクト開発演習の頁 (/luagate/prod-dev) の事実の字。出どころは shegate-web の order-terms.ts で、試験が同じ字であることを確かめる */
  period: "2026年12月から、ご自身の時期に開始",
  expiry: "生涯サポートプランの方は期限なし（当社がスクールを運営する間）、基本エンジニアプランの方は入会から18ヶ月の範囲内",
  guide: "12 月が近づいたら LINE でご案内します",
  /** サイドバーの「12月から」の札を出す最後の日の翌日 (日本の日付)。この日になったら札を消す */
  soonUntil: "2026-12-01",
} as const;

/** サイドバーの入口に「12月から」の札を付けるか。日本の日付で 12/1 の前だけ true */
export function prodDevSoonBadge(now: Date, until: string = PROD_DEV_EXERCISE.soonUntil): boolean {
  const jstToday = new Date(now.getTime() + 9 * 3600_000).toISOString().slice(0, 10);
  return jstToday < until;
}

/** 締め切りの日 (日本の日付) がまだ過ぎていないか。締め切りの日の 23:59 (日本) までは true */
export function prodDevRecruitOpen(now: Date, deadline: string = PROD_DEV_EXERCISE.recruit.deadline): boolean {
  const jstToday = new Date(now.getTime() + 9 * 3600_000).toISOString().slice(0, 10);
  return jstToday <= deadline;
}

/** 締め切りの日を「10月17日(土)」の形にする (同じ札の start「第1期は2026年12月から」と書き方をそろえる) */
export function prodDevDeadlineLabel(deadline: string = PROD_DEV_EXERCISE.recruit.deadline): string {
  const [y, m, d] = deadline.split("-").map(Number);
  const wd = ["日", "月", "火", "水", "木", "金", "土"][new Date(Date.UTC(y, m - 1, d)).getUTCDay()];
  return `${m} 月 ${d} 日 (${wd})`;
}

/**
 * サイドバーの入口と /luagate/prod-dev を誰に出すか。
 * 買った人の印 (bootstrap の hasProdDev) は本番の api-go が返す (#2612、配備済み)。
 * 代表が入口を「全員に見せ、買っていない人には錠と申し込む」と決めたので、受講生と体験の人にも出す。
 * 買っていない人と体験の人は錠と「申し込む」(LP へ)、hasProdDev が true の受講生は錠なしの「始め方」。
 * "staff" に戻せば管理者と講師だけに絞れる (止めたいときの逃げ道)
 */
export const PROD_DEV_ENTRY_AUDIENCE: "staff" | "everyone" = "everyone";

export function canSeeProdDevEntry(
  viewer: { isAdmin: boolean; isInstructor: boolean },
  audience: "staff" | "everyone" = PROD_DEV_ENTRY_AUDIENCE,
): boolean {
  return audience === "everyone" || viewer.isAdmin || viewer.isInstructor;
}

/** 演習を買った人として扱うか。bootstrap の hasProdDev が true の人だけ。体験の人は true でも false (client でも閉じる) */
export function hasProdDevFor(viewer: { hasProdDev?: boolean | null; isTrial?: boolean | null }): boolean {
  return viewer.hasProdDev === true && viewer.isTrial !== true;
}
